import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { GpsService } from '@core/services/gps.service';
import { IntervalService } from '../services/interval.service';
@Injectable({
  providedIn: 'root',
})
export class ActivateGuard implements CanActivate {
  constructor(private intervalService: IntervalService, private _gps: GpsService) {
  }
  canActivate(): boolean {
    this._gps.startWatch().subscribe();
    this.intervalService.startInterval();
    return true;
  }
}
